export default "./dist/stdassets/images/icons/lc_unselect.png";